import { SECTEUR } from "../types";

export const secteurReducer = (
  state = { isLoading: true, data: [] },
  action
) => {
  switch (action.type) {
    case SECTEUR:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };

    default:
      return state;
  }
};
